// Cellar door visits, recorded automatically from POS orders for every customer
// (order source = POS, with location). No staff action needed.

export interface CellarDoorVisit {
  id: string;
  date: string; // YYYY-MM-DD
  location: string;
  staff: string;
  saleTotal: number;
  orderNumber: string;
  // Loyalty points earned on the sale, if the customer is a loyalty member
  pointsEarned?: number;
}

export const contactVisits: CellarDoorVisit[] = [{
  id: 'visit-6',
  date: '2026-09-12',
  location: 'Cellar door',
  staff: 'Jude',
  saleTotal: 146.2,
  orderNumber: '#4188',
  pointsEarned: 146
}, {
  id: 'visit-5',
  date: '2026-08-01',
  location: 'Cellar door',
  staff: 'Mia',
  saleTotal: 89.0,
  orderNumber: '#4102',
  pointsEarned: 89
}, {
  id: 'visit-4',
  date: '2026-06-20',
  location: 'City tasting room',
  staff: 'Sam',
  saleTotal: 212.5,
  orderNumber: '#4021',
  pointsEarned: 212
}, {
  id: 'visit-3',
  date: '2026-04-11',
  location: 'Cellar door',
  staff: 'Jude',
  saleTotal: 64.0,
  orderNumber: '#3944',
  pointsEarned: 64
}, {
  id: 'visit-2',
  date: '2026-02-08',
  location: 'Cellar door',
  staff: 'Mia',
  saleTotal: 178.4,
  orderNumber: '#3870',
  pointsEarned: 178
}, {
  id: 'visit-1',
  date: '2025-12-20',
  location: 'City tasting room',
  staff: 'Sam',
  saleTotal: 98.0,
  orderNumber: '#3791',
  pointsEarned: 98
}];

export function sortVisitsNewestFirst(visits: CellarDoorVisit[]): CellarDoorVisit[] {
  return [...visits].sort((a, b) => b.date.localeCompare(a.date));
}

export function formatVisitTotal(value: number): string {
  return `$${value.toFixed(2)}`;
}
